export const TESTIMONIALS = [
  {
    id: 't1',
    name: 'Chanie Moskovics',
    time: '2 weeks ago',
    quote:
      "Our daughter has blossomed since joining The David Foster Academy. The teachers truly care about each child's individual growth and development.",
  },
  {
    id: 't2',
    name: 'Marcus Johnson',
    time: '1 month ago',
    quote:
      'The afterschool program has been a game-changer for our son. He comes home excited about what he learned, and his confidence has grown so much.',
  },
  {
    id: 't3',
    name: 'Sarah Williams',
    time: '3 weeks ago',
    quote:
      'We toured several preschools and knew immediately this was the right fit. The warm environment and play-based learning approach are exactly what we wanted.',
  },
  {
    id: 't4',
    name: 'David Chen',
    time: '5 days ago',
    quote:
      "The summer program kept our kids engaged and happy. They made new friends and learned so much—we're already signed up for next year!",
  },
  {
    id: 't5',
    name: 'Rachel Goldstein',
    time: '1 week ago',
    quote:
      'The staff at David Foster Academy go above and beyond every single day. My son has made incredible progress socially and academically—I could not be more grateful.',
  },
  {
    id: 't6',
    name: 'Priya Patel',
    time: '2 months ago',
    quote:
      'From the very first visit, we felt welcomed and supported. The curriculum is thoughtfully designed, and our daughter genuinely looks forward to school every morning.',
  },
];
